// Session-level cache for unit detail responses
const unitDetailCache = new Map<string, any>();

export function getUnitDetailCache(vin: string) {
  return unitDetailCache.get(vin) || null;
}

export function setUnitDetailCache(vin: string, data: any) {
  unitDetailCache.set(vin, data);
}

export function clearUnitDetailCache() {
  unitDetailCache.clear();
}

export function clearUnitDetailCacheForVin(vin: string) {
  unitDetailCache.delete(vin);
}
